import { IonButton, IonButtons, IonContent, IonHeader, IonImg, IonItem, IonLabel, IonList, IonTitle,  IonToolbar, IonicSlides, IonCard, IonCardHeader, IonCardTitle } from '@ionic/react';
import React, {  useState } from 'react';
import { IonIcon } from '@ionic/react';
import { alarmSharp, linkSharp, medalSharp,} from 'ionicons/icons';
import { 
  cash, earth, medal, time, calendar, business, sparkles, flag, compass, 
  image, map, images, accessibility, construct, bulb, ribbon 
} from 'ionicons/icons';

import { SitiosArqProps } from '../interfaces';
import { useTranslation } from "react-i18next";

// import required modules

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/controller'
import { Autoplay, Keyboard, Pagination, Scrollbar, Zoom } from 'swiper';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/zoom';
import '@ionic/react/css/ionic-swiper.css';


import closePage from '../assets/close-circle.svg'
import location_white from '../assets/location-pin.svg'


//Estilos de cada carta
import './SitioArqModal.css'

const SitioArqModal = ({
    marker,
    onDismiss,
  }: {
    marker : SitiosArqProps;
    
    onDismiss: () => void;
  }) => {
    const [t, i18n] = useTranslation("global");

    return (
        <>
           <IonHeader className='museo-ion-header'>
          <IonToolbar className='name-header-modal1 toolbar-modal-museo'>
              <IonButtons className='button-close'>
                <IonButton className='text-close-museo' onClick={() => onDismiss()}>
                  <img src={closePage} alt="imageClose" id='icon-close' />
                </IonButton>
              </IonButtons>
              <Swiper
                      // spaceBetween={5}
                      modules={[Autoplay, Keyboard, Pagination, Scrollbar, Zoom, IonicSlides]}
                      autoplay={true}
                      keyboard={true}
                      pagination={{
                        dynamicBullets: true,
                      }}
                      scrollbar={true}
                      zoom={true}
                      slidesPerView={1}
                      onSlideChange={() => console.log('slide change')}
                      onSwiper={(swiper) => console.log(swiper)}
                    >
                    {marker.urlImagen.map((element, index) => 
                  <>
                    <SwiperSlide>
                      <IonCard id='swiper-ioncard'>
                      <img className="img-swiper" alt='{marker.nombre}' src={element} onError={(e) => {
  e.currentTarget.onerror = null; 
  e.currentTarget.src = 'https://mexicoprofundo.app/fallback-imgs/collage-fallback.png';
}}
/>
                        <IonCardHeader>
                          <IonCardTitle>{marker.nombre}</IonCardTitle>
                        </IonCardHeader>
                      </IonCard>
                    </SwiperSlide>
                      </>
                    )
                    }
            </Swiper>
            <IonTitle>
            <div className="title">
                    <div className="localidad">
                        <div className="icon-loc">
                            <IonImg
                                src={location_white}            
                                alt="Location_white"
                            ></IonImg>
                        </div>
                        <div className="lugar">
                            {marker.nombre}
                        </div>
                    </div>
                </div>
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        
        <IonContent fullscreen={true} className="ion-padding">
        <div className="content-museo">
            <div className="title-name">
                <h1>{marker.nombre} - {marker.municipio}</h1>
            </div>
        </div>
        <p>
            {marker.descripcion}
        </p>

        <IonList className='Incluye'>
            <h3>{t("arqueologia.detalles")}</h3>
            <IonItem>
              <IonIcon icon={alarmSharp} slot="start"></IonIcon>
              <IonLabel>{t("arqueologia.horario")}: {marker.horario}</IonLabel>
            </IonItem>

            <IonItem>
              <IonIcon icon={linkSharp} slot="start"></IonIcon>
              <IonLabel className="ion-text-wrap">{marker.sitio_web}</IonLabel>
            </IonItem>

            <IonItem>
              <IonIcon icon={medalSharp} slot="start"></IonIcon>
              <IonLabel className="ion-text-wrap">{t("arqueologia.promocion")}: {marker.promocion}</IonLabel>
            </IonItem>

            {/* Precio */}
            <IonItem>
                <IonIcon icon={cash} slot="start"></IonIcon>
                <IonLabel>{t("arqueologia.precio")}: {marker.precio}</IonLabel>
            </IonItem>

            {/* Tipo */}
            <IonItem>
                <IonIcon icon={earth} slot="start"></IonIcon>
                <IonLabel>{t("arqueologia.tipo")}: {marker.tipo}</IonLabel>
            </IonItem>

            {/* Duración visita */}
            <IonItem>
                <IonIcon icon={time} slot="start"></IonIcon>
                <IonLabel>{t("arqueologia.duracion_visita")}: {marker.duracion_visita}</IonLabel>
            </IonItem>

            {/* Cronología */}
            <IonItem>
                <IonIcon icon={calendar} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.cronologia")}: {marker.cronologia}</IonLabel>
            </IonItem>

            {/* Función original */}
            <IonItem>
                <IonIcon icon={business} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.func_original")}: {marker.func_original}</IonLabel>
            </IonItem>

            {/* Mitos */}
            <IonItem>
                <IonIcon icon={sparkles} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.mitos")}: {marker.mitos}</IonLabel>
            </IonItem>

            {/* Eventos históricos */}
            <IonItem>
                <IonIcon icon={flag} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.eventos_historicos")}: {marker.eventos_historicos}</IonLabel>
            </IonItem>

            {/* Descubrimiento */}
            <IonItem>
                <IonIcon icon={compass} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.descubrimiento")}: {marker.descubrimiento}</IonLabel>
            </IonItem>

            {/* Estructuras icónicas */}
            <IonItem>
                <IonIcon icon={image} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.estructuras_iconicas")}: {marker.estructuras_iconicas}</IonLabel>
            </IonItem>

            {/* Rutas sugeridas */}
            <IonItem>
                <IonIcon icon={map} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.rutas_sugeridas")}: {marker.rutas_sugeridas}</IonLabel>
            </IonItem>

            {/* Colecciones destacadas */}
            <IonItem>
                <IonIcon icon={images} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.colecciones_destacadas")}: {marker.colecciones_destacadas}</IonLabel>
            </IonItem>

            {/* Accesibilidad */}
            <IonItem>
                <IonIcon icon={accessibility} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.accesibilidad")}: {marker.accesibilidad}</IonLabel>
            </IonItem>

            {/* Instalaciones */}
            <IonItem>
                <IonIcon icon={construct} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.instalaciones")}: {marker.instalaciones}</IonLabel>
            </IonItem>

            {/* Recomendaciones */}
            <IonItem>
                <IonIcon icon={bulb} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.recomendaciones")}: {marker.recomendaciones}</IonLabel>
            </IonItem>

            {/* Reconocimientos */}
            <IonItem>
                <IonIcon icon={ribbon} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.reconocimientos")}: {marker.reconocimientos}</IonLabel>
            </IonItem>
        </IonList>


        </IonContent>
        </>
    );
};

export default SitioArqModal;